import styled from "styled-components";
import Typography from "@material-ui/core/Typography";

export const TypographyBreakWord = styled(Typography)`
    word-break: break-all;
`;
